import React, { useEffect, useState } from 'react';
import { cmsList } from '../../api/apiHandler';
import { Loading } from '../../components/loading/loading';
import { useTranslation } from 'react-i18next';
import '../../i18';
import { useLocation } from 'react-router-dom';

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [content, setContent] = useState(null);
    const isBlankLayout = location.pathname === '/app-privacy-policy';

    useEffect(() => {
        const fetchPrivacyPolicy = async () => {
            try {
                setIsLoading(true);
                const response = await cmsList();
                const privacyPolicyContent = response.data.find(page => page.tag_name === "Privacy Policy");
                setContent(privacyPolicyContent);
            } catch (error) {
                console.error('Error fetching Privacy Policy:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPrivacyPolicy();
    }, []);


    if (isLoading) {
        return <Loading />;
    }

    if (!content) {
        return <div>{t('noContent')}</div>;
    }

    if (isBlankLayout) {
        return (
            <div className="course-single-area pd-bottom-90">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('privacyPolicy')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-center' dangerouslySetInnerHTML={{ __html: content.content }} />
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('privacyPolicy')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-center' dangerouslySetInnerHTML={{ __html: content.content }} />
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy;